import React from "react";
import { getLanguageFromUrl, scrollToElemnent } from "../../app/AppHelpers";
import { languages } from "../../translations/Languages";
import Menu from "../menu/Menu";
import styles from "./topBar.css";

class TopBarContainer extends React.Component {
  render() {
    let language = getLanguageFromUrl();
    return (
      <div className={styles.container}>
        <div className="logo">
          <a href="/" className={styles.logoli}>
            opseeker homepage
          </a>
          <a href="http://fintech.global/globalwealthtechsummit/wp-content/uploads/2019/04/WealthTech_100_summary_2019.pdf">
            <div className={styles.featured} />
          </a>
        </div>
        <a href="http://www.moneytime.es/blog" style={{display:'inline-block'}}>
            <div className={styles.moneytime} />
          </a>
        <span className="eu" onClick={() => scrollToElemnent("sponsors")}>
          EU
        </span>
        
        <ul className="ulTop">
          <Menu />
          {languages
            .filter(function (item) {
              return item !== language;
            })
            .map((lang, i) => {
              return (
                <li className="lang" key={i}>
                  <a href={"https://opseeker.com/" + lang} target="_blank" key={lang.key}>
                    {lang}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

export default TopBarContainer;



// WEBPACK FOOTER //
// ./src/containers/topBar/TopBar.js